import { Alert, Dialog, HTMLDisplay, Stack, Typography } from '@all-manager/design-system-v2';
import { Controller } from 'react-hook-form';
import DescriptionField from '../../../../components/modals/components/DescriptionField';
import { DisplayedMeeting } from '../../types';
import { useMeetingDescriptionForm } from './useMeetingDescriptionForm';

type Props = {
  meeting: DisplayedMeeting;
  onClose: () => void;
};

export function MeetingDescriptionModal(props: Props) {
  const hook = useMeetingDescriptionForm(props.meeting, props.onClose);

  return (
    <Dialog
      open
      onClose={props.onClose}
      onSubmit={hook.isAdmin ? hook.onSubmit : undefined}
      maxWidth="md"
      fullWidth
      title={props.meeting.title}
      closeLabel="Fermer"
      actions={hook.isAdmin ? {
        primaryAction: {
          label: 'Enregistrer',
          type: 'submit',
          loading: hook.isPending,
        },
        secondaryAction: {
          label: 'Annuler',
          onClick: props.onClose,
          disabled: hook.isPending,
        },
      } : {
        primaryAction: {
          label: 'Fermer',
          onClick: props.onClose,
        },
      }}
    >
      <Stack spacing={2}>
        {hook.serverError ? <Alert severity="error">{hook.serverError}</Alert> : null}
        <Typography variant="body2">{hook.dateLabel}</Typography>

        {hook.isAdmin ? (
          <Controller
            name="description"
            control={hook.form.control}
            render={({ field }) => (
              <DescriptionField
                value={field.value}
                onChange={field.onChange}
                label="Notes et résumé"
              />
            )}
          />
        ) : props.meeting.description ? (
          <HTMLDisplay content={props.meeting.description} />
        ) : (
          <Typography variant="noItem">Aucune note pour cette réunion.</Typography>
        )}
      </Stack>
    </Dialog>
  );
}
